import * as u from "react";
import { i as C, E as g, x as d, r as x, a as b, c as m } from "../createReactComponent-58f9bea8.mjs";
import { n as i } from "../property-9daa16cd.mjs";
import { r as _ } from "../icon-button-87ac6b5d.mjs";
import { r as A } from "../checkbox-46b40c6a.mjs";
import "../class-map-2994e95e.mjs";
import "../icon-c572aa57.mjs";
import "../tooltip-cb602d1f.mjs";
import "../query-d94c86d2.mjs";
import "../base-e16d29d8.mjs";
const k = C`
  :host .checkbox--group-regular {
    display: flex;
    align-items: center;
    margin-bottom: var(--exo-spacing-x-small);
    gap: var(--exo-spacing-2x-small);
    font: var(--exo-text-label-micro);
    color: var(--exo-text-label-micro-color);
  }

  :host .checkbox--group-parent {
    display: flex;
    align-items: center;
    gap: var(--exo-spacing-2x-small);
    margin-bottom: var(--exo-spacing-x-small);
    font: var(--exo-text-label-standard-semi-bold);
    line-height: calc(1.2 * var(--exo-line-height-heading));
  }

  :host .info-text {
    font: var(--exo-text-label-micro);
    color: var(--exo-color-font-secondary);
  }

  :host .checkbox-group__slot-vertical {
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--exo-spacing-2x-small);
  }

  :host .checkbox-group__slot-horizontal {
    display: flex;
    flex-direction: row;
    gap: var(--exo-spacing-standard);
  }

  :host .nested__checkbox-parent {
    display: flex;
  }

  :host .nested__checkbox-child {
    padding-left: var(--exo-spacing-large);
    list-style: none;
  }

  :host .nested__checkbox-container,
  :host .nested__checkbox-group {
    display: flex;
    flex-direction: column;
  }

  :host .nested__checkbox-group {
    gap: var(--exo-spacing-2x-small);
    margin-block: var(--exo-spacing-none) var(--exo-spacing-none);
    padding-inline-start: var(--exo-spacing-none);
  }

  ::slotted(ex-checkbox) {
    padding: var(--exo-spacing-2x-small) var(--exo-spacing-2x-small)
      var(--exo-spacing-2x-small) var(--exo-spacing-none);
  }
`;
var N = Object.defineProperty, T = Object.getOwnPropertyDescriptor, c = (a, e, t, o) => {
  for (var n, s = o > 1 ? void 0 : o ? T(e, t) : e, r = a.length - 1; r >= 0; r--)
    (n = a[r]) && (s = (o ? n(e, t, s) : n(s)) || s);
  return o && s && N(e, t, s), s;
}, $ = ((a) => (a.REGULAR = "regular", a.PARENT = "parent", a))($ || {}), E = ((a) => (a.VERTICAL = "vertical", a.HORIZONTAL = "horizontal", a))(E || {});
function v(a) {
  return a ? d`<ex-icon-button
      icon="information"
      flavor="branded"
      type="tertiary"
      size="x-small"
      circular=""
      tooltipText=${a}
    ></ex-icon-button>` : b;
}
function f(a) {
  return a ? d`<span class="info-text">(required)</span>` : b;
}
class l extends g {
  constructor() {
    super(...arguments), this.checkboxes = [], this.label = "", this.value = [], this.infoText = "", this.required = !1, this.headerType = "regular", this.alignment = "vertical", this.listenersAttached = !1;
  }
  getAllCheckboxes() {
    return Array.from(this.querySelectorAll("ex-checkbox"));
  }
  updateCheckedCheckbox() {
    this.listenersAttached || (this.getAllCheckboxes().forEach((e) => {
      e.checked = this.value.includes(e.value), e.addEventListener("on-change", this.handleCheckboxChange.bind(this));
    }), this.listenersAttached = !0);
  }
  updated(e) {
    super.update(e), e.has("value") && e.get("value") !== this.value && this.hasUpdated && this.updateCheckedCheckbox();
  }
  handleCheckboxChange(e) {
    const t = e.target, o = t.value;
    t.checked ? this.value.includes(o) || (this.value = Array.isArray(this.value) ? [...this.value, o] : [o]) : this.value = this.value.filter((n) => n !== o), this.dispatchEvent(new CustomEvent("on-change", { detail: this.value }));
  }
  render() {
    return d`
      <div>
        <span class="checkbox--group-${this.headerType}">
          <slot name="label">${this.label}</slot>
          ${v(this.infoText)}${f(this.required)}
        </span>
        <slot class="checkbox-group__slot-${this.alignment}"></slot>
      </div>
    `;
  }
}
l.styles = k, c([i({ type: Array })], l.prototype, "checkboxes", 2), c([i()], l.prototype, "label", 2), c([i({ converter: { fromAttribute: (a) => a ? a.split(",") : [], toAttribute: (a) => a ? a.join(",") : null } })], l.prototype, "value", 2), c([i()], l.prototype, "infoText", 2), c([i({ type: Boolean, reflect: !0 })], l.prototype, "required", 2), c([i({ type: String })], l.prototype, "headerType", 2), c([i({ type: String })], l.prototype, "alignment", 2);
class h extends g {
  constructor() {
    super(...arguments), this.headerType = "regular", this.checkboxData = [], this.label = "", this.infoText = "", this.value = "", this.required = !1;
  }
  handleCheckboxChange(e, t) {
    const o = e.target.checked;
    this.updateNodeCheckedState(t, o), this.updateParentIndeterminateState(t), this.requestUpdate(), this.dispatchCustomEvent("on-change", { node: t });
  }
  updateNodeCheckedState(e, t) {
    e.checked = t, e.children && e.children.length && e.children.forEach((o) => this.updateNodeCheckedState(o, t));
  }
  updateParentIndeterminateState(e) {
    var o, n;
    const t = this.findParentNode(e);
    if (t) {
      const s = ((o = t.children) == null ? void 0 : o.every((p) => p.checked)) ?? !1, r = ((n = t.children) == null ? void 0 : n.some((p) => p.checked || p.indeterminate)) ?? !1;
      t.checked = s, t.indeterminate = r && !s, this.updateParentIndeterminateState(t);
    }
  }
  updateAllParentsIndeterminateState() {
    this.checkboxData.forEach((e) => {
      this.updateParentIndeterminateState(e);
    });
  }
  findParentNode(e) {
    for (const t of this.checkboxData) {
      const o = this.findParentNodeRecursive(t, e);
      if (o)
        return o;
    }
    return null;
  }
  findParentNodeRecursive(e, t) {
    if (e.children && e.children.includes(t))
      return e;
    for (const o of e.children || []) {
      const n = this.findParentNodeRecursive(o, t);
      if (n)
        return n;
    }
    return null;
  }
  renderCheckbox(e) {
    var s;
    const t = (s = e.children) == null ? void 0 : s.map((r) => r.checked || r.indeterminate), o = (r) => this.renderCheckbox(r), n = e.children ? e.children.map((r) => o(r)) : "";
    return d`
      <li class="nested__checkbox-parent">
        <ex-checkbox
          .checked=${e.checked}
          .indeterminate=${(t == null ? void 0 : t.includes(!0)) && !(t != null && t.every(Boolean))}
          .value=${e.value}
          @on-change=${(r) => this.handleCheckboxChange(r, e)}
        >
          <label>${e.label}</label>
        </ex-checkbox>
      </li>
      <li class="nested__checkbox-child">${n}</li>
    `;
  }
  render() {
    return d`
      <div class="nested__checkbox-container">
        <span class="checkbox--group-${this.headerType}">
          <slot name="label">${this.label}</slot>
          ${v(this.infoText)}${f(this.required)}
        </span>
        <ul class="nested__checkbox-group">
          ${this.checkboxData.map((e) => this.renderCheckbox(e))}
        </ul>
      </div>
    `;
  }
}
h.styles = k, c([i({ type: String })], h.prototype, "headerType", 2), c([i({ type: Array })], h.prototype, "checkboxData", 2), c([i()], h.prototype, "label", 2), c([i()], h.prototype, "infoText", 2), c([i()], h.prototype, "value", 2), c([i({ type: Boolean, reflect: !0 })], h.prototype, "required", 2);
const y = (a = "") => {
  x("ex-checkbox-group", l, a), x("ex-nested-checkbox-group", h, a), A(a), _(a);
}, j = m({ tagName: "ex-checkbox-group", elementClass: l, react: u, events: { onChange: "on-change" }, displayName: "ExCheckboxGroup", registerWebComponent: y }), w = m({ tagName: "ex-nested-checkbox-group", elementClass: h, react: u, events: { onChange: "on-change" }, displayName: "ExNestedCheckboxGroup", registerWebComponent: y });
export {
  l as CheckboxGroup,
  E as CheckboxGroupAlignment,
  $ as CheckboxGroupHeaderType,
  j as ExCheckboxGroup,
  w as ExNestedCheckboxGroup,
  h as NestedCheckboxGroup,
  y as register
};
